import * as React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { VscGithubInverted, VscMail, VscSearch } from "react-icons/vsc"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            email
            github
            portfolioK
            portfolioE
            CVK
            CVE
          }
        }
      }
    }
  `)

  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social

  const handleSearchButtonClick = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/search'
    }
  }

  return (
    <div className="bio p-2">
      <StaticImage
        className="bio-avatar bg-white"
        layout="fixed"
        formats={["auto", "webp", "avif"]}
        src="../images/profile-pic.png"
        width={100}
        height={100}
        quality={95}
        alt="Profile picture"
      />
      {author?.name && (
        <div className="flex flex-col items-center">
          <p className="font-title text-point text-xl">{author.name}</p>
          <p className="text-lg font-bold">{author?.summary || null}</p>
          <div className="p-2 space-y-2">
            <p className="flex justify-center space-x-8">
              <Link
                className="ml-1 hover:text-point hover:font-bold"
                target="_blank"
                to={`${social?.github || ``}`}
                aria-label="GitHub 프로필"
              >
                <VscGithubInverted className="inline-block -mt-1 -ml-1 w-8 h-8" />
              </Link>
              <Link
                className="ml-1 hover:text-point hover:font-bold"
                target="_blank"
                to={`mailto:${social?.email || ``}`}
                aria-label="이메일"
              >
                <VscMail className="inline-block -mt-1 -ml-1 w-8 h-8" />
              </Link>
              <button
                className="ml-1 hover:text-point hover:font-bold"
                onClick={handleSearchButtonClick}
                >
                <VscSearch className="inline-block -mt-1 -ml-1 w-7 h-6"/>
              </button>              
            </p>
          </div>
          <a href="https://hits.seeyoufarm.com">
            <img
              src="https://hits.seeyoufarm.com/api/count/incr/badge.svg?url=https%3A%2F%2Fjaehyojjang.github.io&count_bg=%230C3675&title_bg=%23567EB9&icon=octopusdeploy.svg&icon_color=%23E7E7E7&title=%EC%9D%BC%EC%9D%BC+%EB%B0%A9%EB%AC%B8%EC%9E%90+%EC%88%98&edge_flat=false"
              alt="Daily Visitor Count"
            />
          </a>
        </div>
      )}
    </div>
  )
}

export default Bio
